import { render, staticRenderFns } from "./template_manage.vue?vue&type=template&id=06cbec18&scoped=true"
import script from "./template_manage.vue?vue&type=script&lang=js"
export * from "./template_manage.vue?vue&type=script&lang=js"
import style0 from "./template_manage.vue?vue&type=style&index=0&id=06cbec18&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cbec18",
  null
  
)

export default component.exports